export default __webpack_public_path__ + "static/media/figuremap64.502bca68.png";